<template>
  <v-row
    class="mb-6"
    justify="center"
    dense
    style="background-color: #aed581; border-radius: 8px"
  >
    <v-col
      cols="12"
      v-for="(item, index) in displayItem"
      :key="index"
      class="py-0 px-0"
    >
      <div
        style="width: 100%; overflow: hidden"
        :style="{
          height: checkStyleAtBottom(index) ? '180px' : '152px',
        }"
      >
        <div
          class="d-flex"
          style="width: 100%; height: 100%; position: relative"
        >
          <!-- ========== ========== Image ========== ========== -->
          <div
            class="item-box"
            :style="{
              'margin-right': checkAlignRight(index) ? '48px' : '',
              'margin-left': checkAlignRight(index) ? 'auto' : '48px',
            }"
            @click="openDialog(item)"
          >
            <div
              v-if="checkIsDisabled(item)"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 2;
                background: rgba(255, 255, 255, 0.5);
                backdrop-filter: grayscale(100%) brightness(80%) contrast(120%);
                border-radius: inherit;
              "
            ></div>

            <div
              v-if="checkBgStamp(item)"
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 2;
                background: rgba(255, 255, 255, 0.5);
                border-radius: inherit;
              "
            ></div>

            <!-- stamp text -->
            <div
              v-if="displayStyle == 'stamp' && item.is_completed"
              class="justify-center align-center"
              style="
                width: 95%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(-20deg); /* Center and tilt */
                text-align: center;
                border-radius: inherit;
                padding: 2px 4px;
                font-weight: bold;
                text-transform: uppercase;
                opacity: 0.9;
                z-index: 3;
                display: block;
              "
              :style="{
                color: displayStyleColor || '#f44336',
                border: '4px solid ' + (displayStyleColor || '#f44336'),
                'box-shadow':
                  '0 0 0 3px ' + (displayStyleColor || '#f44336') + '4d',
                'background-color': (displayStyleColor || '#f44336') + '03',
              }"
            >
              <p
                class="ma-0 pa-0"
                style="
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: normal;
                  text-align: center;
                "
              >
                {{ displayStyleText }}
              </p>
            </div>

            <!-- stamp image -->
            <v-img
              v-if="displayStyle == 'stamp_image' && item.is_completed"
              :src="
                displayStyleImage ||
                'https://www.onlygfx.com/wp-content/uploads/2017/12/ok-stamp-4-1024x1024.png'
              "
              cover
              height="80%"
              width="80%"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 3;
                opacity: 0.9;
              "
            />

            <v-img
              :src="item.image_url"
              contain
              height="100%"
              width="100%"
              class="ma-auto"
              z-index="100"
              style="border-radius: inherit"
            >
            </v-img>
          </div>

          <!-- ========== ========== Title ========== ========== -->
          <div class="title-box" :style="styleTitle(index, 'box')">
            <div
              class="description-label title-text"
              :style="styleTitle(index, 'text')"
            >
              {{ item.title }}
            </div>
          </div>

          <!-- ========== ========== Icon ========== ========== -->
          <div
            v-if="!checkAlignRight(index)"
            style="position: absolute; bottom: 0; right: 12px"
          >
            <TreasureIcon width="56px" height="56px" />
          </div>
          <div
            v-if="checkLeftIcon(index, 'balloon')"
            style="position: absolute; right: 136px; z-index: 2"
            :style="{
              bottom: checkStyleAtBottom(index) ? '92px' : '72px',
            }"
          >
            <BalloonIcon width="64px" height="64px" />
          </div>
          <div
            v-if="checkLeftIcon(index, 'flag')"
            style="position: absolute; bottom: 0; left: 8px; z-index: 2"
          >
            <FlagIcon width="64px" height="64px" />
          </div>
          <!-- Icon Grass -->
          <div
            v-if="checkAlignRight(index) && !checkLastItem(index)"
            style="position: absolute; top: 0px; left: 40px; z-index: 2"
          >
            <GrassIcon width="64px" height="64px" />
          </div>
          <div
            v-if="!checkAlignRight(index)"
            style="position: absolute; top: 0px; left: 160px; z-index: 2"
          >
            <GrassIcon width="64px" height="64px" />
          </div>

          <!-- ========== ========== Main Radius ========== ========== -->
          <div
            class="main-radius"
            :style="{
              right: checkAlignRight(index) ? '16px' : '',
              left: checkAlignRight(index) ? '' : '16px',
              'border-radius': checkAlignRight(index)
                ? '0px 92px 92px 0px'
                : '92px 0px 0px 92px',
              'background-color': checkComplete(item) ? '#81D4FA' : '#ECEFF1',
            }"
          >
            <template v-if="checkComplete(item)">
              <div
                style="position: absolute; top: 32px"
                :style="{
                  right: checkAlignRight(index) ? '20px' : '48px',
                }"
              >
                <WaveIcon color="#2196F3" width="24px" height="24px" />
              </div>
              <div style="position: absolute; top: 132px; right: 32px">
                <WaveIcon color="#2196F3" width="24px" height="24px" />
              </div>
            </template>
          </div>

          <!-- ========== ========== Filler Radius ========== ========== -->
          <div
            v-if="!checkLastItem(index)"
            class="filler-radius"
            :style="{
              right: checkAlignRight(index) ? '' : '16px',
              left: checkAlignRight(index) ? '16px' : '',
              'border-radius': checkAlignRight(index)
                ? '92px 0px 0px 92px'
                : '0px 92px 92px 0px',
              'background-color':
                (index > 0 && checkComplete(displayItem[index - 1])) ||
                (index == 0 && checkComplete(item) && page == totalPage) ||
                (index == 0 &&
                  displayItemNext.length > 0 &&
                  checkComplete(
                    displayItemNext[displayItemNext.length - 1],
                    item
                  ))
                  ? '#81D4FA'
                  : '#eceff1',
            }"
          ></div>

          <!-- ========== ========== Line Connect ========== ========== -->
          <div
            class="line-connect"
            :style="{
              'background-color': checkComplete(item) ? '#81D4FA' : '#eceff1',
            }"
          >
            <template v-if="checkComplete(item)">
              <div style="position: absolute; bottom: 0px; left: 20px">
                <WaveIcon color="#2196F3" width="32px" height="32px" />
              </div>
              <div style="position: absolute; bottom: -12px; right: 72px">
                <WaveIcon color="#2196F3" width="32px" height="32px" />
              </div>
              <div style="position: absolute; bottom: -2px; right: 20px">
                <WaveIcon color="#2196F3" width="32px" height="32px" />
              </div>
            </template>
          </div>

          <!-- ========== ========== Line Start ========== ========== -->
          <div
            v-if="checkStyleAtBottom(index)"
            class="line-start"
            :style="{
              'background-color': checkComplete(item) ? '#81D4FA' : '#eceff1',
            }"
          >
            <template v-if="checkComplete(item)">
              <div style="position: absolute; bottom: 0px; left: 20px">
                <WaveIcon color="#2196F3" width="32px" height="32px" />
              </div>
              <div style="position: absolute; bottom: -12px; left: 60px">
                <WaveIcon color="#2196F3" width="32px" height="32px" />
              </div>
              <div style="position: absolute; bottom: -2px; right: 20px">
                <WaveIcon color="#2196F3" width="32px" height="32px" />
              </div>
            </template>
          </div>
          <div
            v-if="checkStyleAtBottom(index) && page > 1"
            class="continue-radius"
            :style="{
              right: checkAlignRight(index) ? '' : '16px',
              left: checkAlignRight(index) ? '16px' : '',
              'border-radius': checkAlignRight(index)
                ? '92px 0px 0px 92px'
                : '0px 92px 92px 0px',
              'background-color': checkComplete(item) ? '#81D4FA' : '#ECEFF1',
            }"
          >
            <template v-if="checkComplete(item)">
              <div
                style="position: absolute; top: 32px"
                :style="{
                  right: checkAlignRight(index) ? '20px' : '48px',
                }"
              >
                <WaveIcon color="#2196F3" width="24px" height="24px" />
              </div>
              <div style="position: absolute; top: 132px; right: 32px">
                <WaveIcon color="#2196F3" width="24px" height="24px" />
              </div>
            </template>
          </div>
          <div
            v-if="checkStyleAtStart(index)"
            style="position: absolute; bottom: 24px; left: 56px; z-index: 2"
          >
            <GirlIcon width="60px" height="60px" />
          </div>
          <div
            v-if="checkStyleAtStart(index)"
            style="position: absolute; bottom: 0px; left: 32px; z-index: 2"
          >
            <BoyIcon width="56px" height="56px" />
          </div>

          <!-- ========== ========== End ========== ========== -->
          <div
            v-if="checkLastItem(index)"
            class="end-radius"
            :style="{
              right: checkAlignRight(index) ? '' : '44px',
              left: checkAlignRight(index) ? '44px' : '',
              'background-color': checkComplete(item) ? '#81D4FA' : '#eceff1',
              'border-radius': checkAlignRight(index)
                ? '50px 0px 50px 50px'
                : '0px 50px 50px 50px',
            }"
          >
            <template>
              <div style="position: absolute; bottom: 0px; left: 6px">
                <SuccessIcon
                  width="48px"
                  height="48px"
                  :disable="!checkComplete(item)"
                />
              </div>
            </template>
          </div>

          <!-- ========== ========== Button Up & Down ========== ========== -->
          <div
            v-if="page != totalPage && index == 0"
            style="position: absolute; top: 8px; right: 8px"
          >
            <v-btn fab x-small :color="site.color" dark @click="handleClickUp">
              <v-icon large>mdi-chevron-up</v-icon>
            </v-btn>
          </div>
          <div
            v-if="page > 1 && index + 1 == displayItem.length"
            style="position: absolute; bottom: 8px; right: 8px"
          >
            <v-btn
              fab
              x-small
              :color="site.color"
              dark
              @click="handleClickDown"
            >
              <v-icon large>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import TreasureIcon from "./icon/treasure-icon.vue";
import FlagIcon from "./icon/flag-icon.vue";
import BalloonIcon from "./icon/balloon-icon.vue";
import WaveIcon from "./icon/wave-icon.vue";
import BoyIcon from "./icon/boy-icon.vue";
import GirlIcon from "./icon/girl-icon.vue";
import GrassIcon from "./icon/grass-icon.vue";
import SuccessIcon from "./icon/success-icon.vue";

export default {
  name: "QuestTrackingDataItemRoute",
  emits: ["onOpenDialog"],
  props: {
    questTrackingData: {
      type: Array,
      required: true,
    },
    conditionSpecial: {
      type: Object,
    },
  },
  components: {
    TreasureIcon,
    FlagIcon,
    BalloonIcon,
    WaveIcon,
    BoyIcon,
    GirlIcon,
    GrassIcon,
    SuccessIcon,
  },
  data() {
    return {
      displayStyle: null,
      displayStyleText: null,
      displayStyleImage: null,
      displayStyleColor: null,
      mode: "normal",
      isDisabled: false,
      questTrackingDataItem: [],

      page: 1,
      totalPage: 1,
      limitPerPage: 4,
      startFromRight: true,
      fromBeforeIconLeft: {
        1: "flag",
      },
    };
  },
  mounted() {
    if (this.conditionSpecial != null) {
      this.displayStyle = this.conditionSpecial.completion_display_style;
      this.displayStyleText =
        this.conditionSpecial.completion_display_text ?? "success";
      this.displayStyleImage =
        this.conditionSpecial.completion_display_image_url ??
        "https://www.onlygfx.com/wp-content/uploads/2017/12/ok-stamp-4-1024x1024.png";
      this.displayStyleColor = this.conditionSpecial.completion_display_color;
      this.mode = this.conditionSpecial.mode ?? "normal";
    } else {
      this.displayStyle = "disable";
    }

    // ========== ========== ========== ==========
    const _questTrackingData = [...this.questTrackingData];
    this.questTrackingDataItem = _questTrackingData;
    this.totalPage = Math.ceil(
      this.questTrackingDataItem.length / this.limitPerPage
    );
  },
  methods: {
    openDialog(item) {
      const selectItem = {
        ...item,
        mode: this.mode,
      };
      this.$emit("onOpenDialog", selectItem);
    },
    checkBgStamp(item) {
      if (this.displayStyle == "stamp" || this.displayStyle == "stamp_image") {
        if (item.is_completed) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkIsDisabled(item) {
      if (this.displayStyle == "highlight") {
        if (item.is_completed) {
          return false;
        } else {
          return true;
        }
      } else if (this.displayStyle == "disable") {
        if (item.is_completed) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    // ========== ========== Style ========== ==========
    checkStyleAtStart(index) {
      return this.page == 1 && this.checkStyleAtBottom(index);
    },
    checkStyleAtBottom(index) {
      return index + 1 == this.displayItem.length;
    },
    checkLastItem(index) {
      return index == 0 && this.page == this.totalPage;
    },
    checkComplete(param, param_ref) {
      let check = param.is_completed;
      let list = [...this.questTrackingDataItem];
      list.reverse();
      for (let item of list) {
        if (item.sequence < param.sequence && !item.is_completed) {
          check = false;
        }
      }
      if (param_ref && !param_ref.is_completed) {
        check = false;
      }
      return check;
    },
    styleTitle(index, type) {
      let style = {};
      if (type == "box") {
        style = {
          top: this.checkStyleAtStart(index) ? "50%" : "calc(50% + 12px)",
          right: this.checkAlignRight(index) ? "180px" : "",
          left: this.checkAlignRight(index) ? "" : "180px",
        };
      } else if (type == "text") {
        style = {
          "text-align": this.checkAlignRight(index) ? "end" : "start",
        };
      }
      return style;
    },
    checkAlignRight(index) {
      let check = true;
      const total = this.displayItem.length;
      // ตรวจสอบว่าอันบนสุดตำแหน่งอะไร
      const lastToRight =
        total % 2 == 0 ? !this.startFromRight : this.startFromRight;
      if (this.startFromRight) {
        check = index % 2 == 0 ? lastToRight : !lastToRight;
      }
      return check;
    },
    getLastLeftIcon() {
      const total = this.displayItem.length;
      const right_count = Math.ceil(total / 2);
      let last = "";
      if (this.fromBeforeIconLeft[this.page] == "flag") {
        last = right_count % 2 == 0 ? "flag" : "balloon";
      } else {
        last = right_count % 2 == 0 ? "balloon" : "flag";
      }
      return last;
    },
    checkLeftIcon(index, type) {
      let check = false;
      if (this.checkAlignRight(index)) {
        let last = this.getLastLeftIcon();
        if (last == type) {
          check = true;
        }
        const _index = Math.floor(index / 2);
        for (let i = 0; i < _index; i++) {
          check = !check;
        }
      }
      return check;
    },

    // ========== ========== ========== ==========
    handleClickUp() {
      const _page = this.page + 1;
      this.fromBeforeIconLeft[_page] = this.getLastLeftIcon();
      this.page++;
    },
    handleClickDown() {
      this.page--;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),

    displayItem() {
      const limit = this.limitPerPage;
      // ========== ========== ========== ==========
      let start = (this.page - 1) * limit;
      let end = start + limit;
      let _list = [...this.questTrackingDataItem];
      let list = _list.slice(start, end);
      if (list.length < limit) {
        const diff = limit - list.length;
        start = start - diff;
        end = start + limit;
        list = _list.slice(start, end);
      }
      // ========== ========== ========== ==========
      if (_list.length <= limit) {
        list = [..._list];
      }
      list.reverse();
      // ========== ========== ========== ==========
      return list;
    },
    displayItemNext() {
      const limit = this.limitPerPage;
      // ========== ========== ========== ==========
      let start = this.page * limit;
      let end = start + limit;
      let _list = [...this.questTrackingDataItem];
      let list = _list.slice(start, end);
      if (list.length < limit) {
        const diff = limit - list.length;
        start = start - diff;
        end = start + limit;
        list = _list.slice(start, end);
      }
      // ========== ========== ========== ==========
      if (_list.length <= limit) {
        list = [..._list];
      }
      list.reverse();
      // ========== ========== ========== ==========
      return list;
    },
    displayItemBefore() {
      if (this.page - 2 < 0) return [];
      const limit = this.limitPerPage;
      // ========== ========== ========== ==========
      let start = (this.page - 2) * limit;
      let end = start + limit;
      let _list = [...this.questTrackingDataItem];
      let list = _list.slice(start, end);
      if (list.length < limit) {
        const diff = limit - list.length;
        start = start - diff;
        end = start + limit;
        list = _list.slice(start, end);
      }
      // ========== ========== ========== ==========
      if (_list.length <= limit) {
        list = [..._list];
      }
      list.reverse();
      // ========== ========== ========== ==========
      return list;
    },
  },
  filters: {},
};
</script>

<style scoped>
.item-box {
  width: 120px;
  height: 120px;
  position: relative;
  border-radius: 50%;
  top: 32px;
  z-index: 1;
  box-shadow: rgba(99, 99, 99, 0.2) 0px -4px 4px 0px;
  background-color: #ffffff;
}

.title-box {
  width: calc(100% - 190px);
  position: absolute;
  transform: translateY(-50%);
  z-index: 3;
}
.title-text {
  text-shadow: #ffffff 1px 1px 1px;
}
.description-label {
  font-size: 20px;
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.line-start {
  width: calc(100% - 180px);
  height: 28px;
  position: absolute;
  bottom: 0;
  border-radius: 16px;
  margin-left: 92px;
}
.line-connect {
  width: calc(100% - 180px);
  height: 32px;
  position: absolute;
  top: 0;
  border-radius: 16px;
  margin-left: 92px;
}

.main-radius {
  width: 92px;
  height: 184px;
  position: absolute;
  top: 0px;
}
.filler-radius {
  width: 92px;
  height: 184px;
  position: absolute;
  top: -152px;
}
.continue-radius {
  width: 92px;
  height: 184px;
  position: absolute;
  top: 152px;
}
.end-radius {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0px;
}
</style>